import { render, staticRenderFns } from "./GdprTermsOverlay.vue?vue&type=template&id=bf558e9a&"
import script from "./GdprTermsOverlay.js?vue&type=script&lang=js&"
export * from "./GdprTermsOverlay.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/lib/jenkins/workspace/mijnmooiestraat.vlaanderen/staging.mijnmooiestraat.vlaanderen/pro-staging.mijnmooiestraat.vlaanderen/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('bf558e9a')) {
      api.createRecord('bf558e9a', component.options)
    } else {
      api.reload('bf558e9a', component.options)
    }
    module.hot.accept("./GdprTermsOverlay.vue?vue&type=template&id=bf558e9a&", function () {
      api.rerender('bf558e9a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/js/components/GdprTermsOverlay/GdprTermsOverlay.vue"
export default component.exports